<ng-container>
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-4">
        <div class="col-md-6">
          <span class="d-flex justify-content-start align-items-center">
            <i
              (click)="goBack()"
              class="fa fa-arrow-left pointer mr-2"
              aria-hidden="true"></i>
            <h1 class="payment-history-title">Partial Credit Note</h1>
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 col-sm-4 col-xs-6">
          <span class="label-style">Name :</span>

          {{
            module !== constants.ACM_PARTIAL
              ? invoiceDetails.quotation?.client?.name
              : invoiceDetails.serviceOrder?.client?.name ||
                invoiceDetails.serviceOrder?.acmsAircraft?.tailName
          }}
        </div>
        <!-- <div class="col-md-4 col-sm-4 col-xs-6">
          <span class="label-style">Bank Name :</span>
          {{
            module !== constants.ACM_PARTIAL && module !== SALES_ORDER
              ? invoiceDetails.quotation?.bank?.name
              : invoiceDetails.bank?.name
          }}
        </div> -->
        <div class="col-md-4 col-sm-4 col-xs-6">
          <span class="label-style">Currency :</span>

          {{
            module !== constants.ACM_PARTIAL
              ? invoiceDetails.quotation?.currency?.code
              : invoiceDetails.serviceOrder?.currency?.code
          }}
        </div>

        <ng-container
          *ngIf="
            invoiceDetails?.quotation?.totalOutOfScope ||
            invoiceDetails?.serviceOrder?.totalOutOfScope
          ">
          <div class="col-md-4 col-sm-4 col-xs-6">
            <span class="label-style"> Total (Excluding VAT) :</span>

            <ng-container *ngIf="module !== constants.ACM_PARTIAL">
              <span
                *ngIf="
                  invoiceDetails?.quotation?.totalExcludingVat ||
                  invoiceDetails?.quotation?.totalOutOfScope
                ">
                {{ invoiceDetails.quotation?.currency?.code }}
              </span>
              {{ getTotalTaxableAmount() | number: '1.2-2' }}
            </ng-container>
            <ng-container *ngIf="module === constants.ACM_PARTIAL">
              <span
                *ngIf="
                  invoiceDetails?.serviceOrder?.totalExcludingVat ||
                  invoiceDetails?.serviceOrder?.totalOutOfScope
                ">
                {{ invoiceDetails.serviceOrder?.currency?.code }}
              </span>
              {{ getACMSTotalTaxableAmount() | number: '1.2-2' }}
            </ng-container>
          </div>

          <div class="col-md-4 col-sm-4 col-xs-6">
            <span class="label-style"> Total Out Of Scope : </span>
            <ng-container *ngIf="module !== constants.ACM_PARTIAL">
              <span *ngIf="invoiceDetails?.quotation?.totalOutOfScope">
                {{ invoiceDetails.quotation?.currency?.code }}
              </span>
              {{ invoiceDetails.quotation?.totalOutOfScope | number: '1.2-2' }}
            </ng-container>

            <ng-container *ngIf="module === constants.ACM_PARTIAL">
              <span *ngIf="invoiceDetails?.serviceOrder?.totalOutOfScope">
                {{ invoiceDetails.serviceOrder?.currency?.code }}
              </span>
              {{
                invoiceDetails.serviceOrder?.totalOutOfScope | number: '1.2-2'
              }}
            </ng-container>
          </div>
        </ng-container>

        <div class="col-md-4 col-sm-4 col-xs-6">
          <span class="label-style"> Total Taxable Amount :</span>
          <ng-container *ngIf="module !== constants.ACM_PARTIAL">
            <span
              *ngIf="
                invoiceDetails?.quotation?.totalExcludingVat ||
                invoiceDetails?.quotation?.totalOutOfScope
              ">
              {{ invoiceDetails.quotation?.currency?.code }}
            </span>
            {{ getTotalTaxableAmount() | number: '1.2-2' }}
          </ng-container>
          <ng-container *ngIf="module === constants.ACM_PARTIAL">
            <span
              *ngIf="
                invoiceDetails?.serviceOrder?.totalExcludingVat ||
                invoiceDetails?.serviceOrder?.totalOutOfScope
              ">
              {{ invoiceDetails.serviceOrder?.currency?.code }}
            </span>
            {{ getACMSTotalTaxableAmount() | number: '1.2-2' }}
          </ng-container>
        </div>

        <div class="col-md-4 col-sm-4 col-xs-6">
          <span class="label-style">Total Vat (15%) :</span>
          <ng-container *ngIf="module !== constants.ACM_PARTIAL">
            <span>
              {{ invoiceDetails.quotation?.currency?.code }}
            </span>
            {{ invoiceDetails.quotation?.vatAmount | number: '1.2-2' }}
          </ng-container>

          <ng-container *ngIf="module === constants.ACM_PARTIAL">
            <span>
              {{ invoiceDetails.serviceOrder?.currency?.code }}
            </span>
            {{ invoiceDetails.serviceOrder?.vatAmount | number: '1.2-2' }}
          </ng-container>
        </div>

        <div class="col-md-4 col-sm-4 col-xs-6">
          <span class="label-style">Credit Balace :</span>

          <ng-container *ngIf="module !== constants.ACM_PARTIAL">
            <span *ngIf="invoiceDetails?.quotation?.creditBalance">
              {{ invoiceDetails.quotation?.currency?.code }}
            </span>

            {{ invoiceDetails.quotation?.creditBalance | number: '1.2-2' }}
          </ng-container>

          <ng-container *ngIf="module === constants.ACM_PARTIAL">
            <span *ngIf="invoiceDetails?.quotation?.creditBalance">
              {{ invoiceDetails.serviceOrder?.currency?.code }}
            </span>

            {{ invoiceDetails.quotation?.creditBalance | number: '1.2-2' }}
          </ng-container>
        </div>

        <div class="col-md-4 col-sm-4 col-xs-6">
          <span class="label-style">Total :</span>

          <ng-container *ngIf="module !== constants.ACM_PARTIAL">
            <span *ngIf="invoiceDetails?.quotation?.total">
              {{ invoiceDetails.quotation?.currency?.code }}
            </span>

            {{ invoiceDetails.quotation?.total | number: '1.2-2' }}
          </ng-container>

          <ng-container *ngIf="module === constants.ACM_PARTIAL">
            <span *ngIf="invoiceDetails?.serviceOrder?.total">
              {{ invoiceDetails.serviceOrder?.currency?.code }}
            </span>

            {{ invoiceDetails.serviceOrder?.total | number: '1.2-2' }}
          </ng-container>
        </div>

        <!-- </div> -->
      </div>
    </div>
  </section>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card card-primary">
            <div class="card-header">
              <div class="card-title">
                {{ 'New Credit Notes' }}
              </div>
            </div>
            <form [formGroup]="invoiceForm" (ngSubmit)="onSubmit()">
              <div class="card-body">
                <div class="row">
                  <!-- Dynamic "items" entries -->
                  <div class="col-md-12" formArrayName="lineItems">
                    <div
                      *ngFor="let item of lineItems.controls; let i = index"
                      [formGroupName]="i">
                      <div class="border p-3 mb-3">
                        <div class="row">
                          <div class="col-md-11">
                            <div class="row">
                              <div class="col-md-3">
                                <div class="form-group">
                                  <label for="itemDescription"
                                    >Item Description
                                    <span class="text-danger">*</span></label
                                  >
                                  <textarea
                                    class="form-control"
                                    formControlName="itemDescription"
                                    [ngClass]="{
                                      'is-invalid':
                                        item
                                          .get('itemDescription')
                                          ?.hasError('required') &&
                                        item.get('itemDescription')?.touched
                                    }"
                                    placeholder="Enter Description"></textarea>
                                  <span class="error invalid-feedback"
                                    >Enter Description
                                  </span>
                                </div>
                              </div>

                              <div class="col-md-3">
                                <div class="form-group">
                                  <label for="quantity"
                                    >Quantity
                                    <span class="text-danger">*</span></label
                                  >
                                  <input
                                    [ngClass]="{
                                      'is-invalid':
                                        (item
                                          .get('quantity')
                                          ?.hasError('pattern') &&
                                          item.get('quantity')?.touched) ||
                                        (item
                                          .get('quantity')
                                          ?.hasError('required') &&
                                          item.get('quantity')?.touched)
                                    }"
                                    type="text"
                                    class="form-control"
                                    formControlName="quantity"
                                    placeholder="Enter the Quantity" />
                                  <span class="error invalid-feedback"
                                    >Please enter a valid Quantity</span
                                  >
                                </div>
                              </div>

                              <div class="col-md-3">
                                <div class="form-group">
                                  <label for="hourlyRate"
                                    >Unit Price
                                    <span class="text-danger">*</span></label
                                  >
                                  <input
                                    [ngClass]="{
                                      'is-invalid':
                                        (item
                                          .get('unitPrice')
                                          ?.hasError('pattern') &&
                                          item.get('unitPrice')?.touched) ||
                                        (item
                                          .get('unitPrice')
                                          ?.hasError('required') &&
                                          item.get('unitPrice')?.touched)
                                    }"
                                    type="text"
                                    class="form-control"
                                    formControlName="unitPrice"
                                    placeholder="Enter the Unit Price" />
                                  <span class="error invalid-feedback"
                                    >Please enter a valid unit price</span
                                  >
                                </div>
                              </div>
                              <div class="col-md-3">
                                <div class="form-group">
                                  <label for="vat"
                                    >VAT
                                    <span class="text-danger">*</span></label
                                  >
                                  <ng-select
                                    id="vat"
                                    name="vat"
                                    [ngClass]="{
                                      'is-invalid':
                                        item.get('vat')?.hasError('required') &&
                                        item.get('vat')?.touched
                                    }"
                                    formControlName="vat"
                                    [items]="vatOptions"
                                    [multiple]="false"
                                    [closeOnSelect]="true"
                                    [bindLabel]="'percentage'"
                                    [searchable]="true"
                                    placeholder="Select VAT">
                                  </ng-select>

                                  <span class="error invalid-feedback"
                                    >Please select a vat</span
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            *ngIf="i > 0"
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            "
                            class="col-md-1">
                            <span
                              (click)="removelegs(i)"
                              (keydown)="removelegs(i)"
                              tabindex="0"
                              class="remove-icon"
                              (click)="removelegs(i)">
                              <i class="fa fa-times delete-icon pointer"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="row"> -->
                  <div class="col-md-12 text-right">
                    <button
                      (click)="addlineItems()"
                      [disabled]="lineItems.invalid"
                      class="btn btn-primary mb-4 ml-2 float-right">
                      <i class="fa fa-plus delete-icon pointer"></i> Add Item
                    </button>
                  </div>
                  <!-- </div> -->
                </div>
              </div>
            </form>
            <div class="card-footer">
              <div class="card-footer-display">
                <button
                  class="btn btn-secondary float-right"
                  type="button"
                  (click)="goBack()">
                  Cancel
                </button>
                <button
                  [disabled]="invoiceForm.invalid"
                  class="btn btn-primary float-right custom-button"
                  type="submit"
                  (click)="onSubmit()">
                  <ng-container *ngIf="createLoading; else submitText">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"></span>
                  </ng-container>
                </button>
                <ng-template #submitText>Submit</ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</ng-container>
